import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';

import '@core/ui/styles';
import './index.scss';
import { dismissLoader } from '@core/ui/utils/dismissLoader';

// Apply initial theme before React mounts (supplements the inline HTML script)
(() => {
  const stored = localStorage.getItem('core-theme') || localStorage.getItem('theme');
  let initialTheme: 'dark' | 'light' = 'dark';
  if (stored === 'g100') initialTheme = 'dark';
  else if (stored === 'g10') initialTheme = 'light';
  else if (stored === 'light') initialTheme = 'light';
  else if (stored === 'dark') initialTheme = 'dark';

  document.documentElement.setAttribute('data-theme', initialTheme);
  document.documentElement.setAttribute('data-effects', 'glass');
  document.body.classList.add(`core-theme-${initialTheme}`);
})();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);

dismissLoader(); 